var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lyf-ui-badge"},[_c('div',{staticClass:"lyf-ui-badge-dot",class:{ 
      small: _vm.origin === 'center', 
      border: _vm.border, 
      content: _vm.badgeContent,
      single: _vm.singleContent
    },style:({
      backgroundColor: _vm.color
    })},[_vm._v(_vm._s(_vm.badgeContent))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }